import script from "./languageSet.vue?vue&type=script&setup=true&lang=js"
export * from "./languageSet.vue?vue&type=script&setup=true&lang=js"

import "./languageSet.vue?vue&type=style&index=0&id=76736b39&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76736b39"]])

export default __exports__